<template>
  <div class="padding-xl padding-top">
    <div class="padding-bottom text-red ">
      <el-button @click="$router.back()" type="text" size="medium">
        <span class="text-lg"><i class="cuIcon-back"></i>返回列表</span>
      </el-button>
    </div>
    <div class="shadow-warp">
      <el-collapse accordion @change="activeChanged" class="padding">
        <el-collapse-item v-for="(item,index) in list" :key="index" :name="item.LOGIST_ID">
          <template slot="title">
            {{ item.LOGIST_DESC }} | {{item.LOGIST_COMPANY_NAME}} | {{item.LOGIST_NO}} | {{item.DELIVERY_DATE}}
          </template>
          <div>
            <el-timeline>
              <el-timeline-item
                v-for="(activity, i) in item.activities"
                :key="i"
                :timestamp="activity.time">
                {{ activity.context }}
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import bs from '@/services/data/bs'

export default {
  name: 'logistics-info',
  data () {
    return {
      order: {},
      list: [],
      map: {}
    }
  },
  created () {
    this.order = JSON.parse(sessionStorage.getItem('order'))
    bs.order.queryLogistics(this.order.no, (res) => {
      if (res.code === 200 && res.data.length > 0) {
        this.list = res.data
        for (let i = 0; i < this.list.length; i++) {
          const a = this.list[i]
          this.map[a.LOGIST_ID] = a
        }
      }
    })
  },
  methods: {
    activeChanged (activeNames) {
      if (activeNames && !this.map[activeNames].activities) {
        bs.order.queryLogisticsDetail(this.map[activeNames].LOGIST_NO, (res) => {
          if (res.code === 200) {
            this.map[activeNames].activities = JSON.parse(res.data)
            this.$forceUpdate()
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.info-label {
  width: 100px;
  padding: 2px 0;
  text-align: right;
}

.view-label {
  min-width: 200px;
}
</style>
